// extracted by mini-css-extract-plugin
export default {"root":"VMatchLoading_root_n-V9f"};